<template>
  <b-container fluid>
    <backlink />
    <h1>FAQ</h1>

    <AdminTable :config="config"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "FaqList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Faq/FaqList.vue